<template>
  <div
    class="ob1-promotional-code-info">
    <wptv-alert
      type="info"
      :message="message" />
  </div>
</template>

<script>
import WptvAlert from '../../../alert/Alert'

export default {
  name: 'PromotionalCodeInfo',
  components: {
    WptvAlert
  },
  props: {
    message: {
      type: String,
      required: true
    }
  }
}

</script>
